import React from "react";
import "./messageSuccess.scss";
import {Button} from "antd";

export function MessageSuccess({title, description = "", isSuccess, handleButtonClick, btnText = "Aceptar"}) {
    return (
        <div className="message-success">
            {isSuccess ?
                <svg className="checkmark" viewBox="0 0 52 52">
                    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                    <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
                :
                <svg className="cross" viewBox="0 0 52 52">
                    <circle className="cross__circle" cx="26" cy="26" r="25" fill="none"/>
                    <path className="cross__path cross__path--right" fill="none" d="M16,16 l20,20" />
                    <path className="cross__path cross__path--right" fill="none" d="M16,36 l20,-20" />
                </svg>
            }
            <h4>{title}</h4>
            {description && (<p>{description}</p>)}
            <div className="form-light__footer center">
                <Button
                    htmlType={'button'}
                    type={"primary"}
                    onClick={handleButtonClick}
                >
                    {btnText}
                </Button>
            </div>
        </div>
    );
}